export const APP_CONTENT_WIDTH = "330px";
